import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createAwsSubnetIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M34 6H6V34H34V6Z" fill="#7AA116"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6752 21.4343C20.4494 21.4343 21.0794 22.0636 21.0794 22.8378C21.0794 23.612 20.4494 24.242 19.6752 24.242C18.901 24.242 18.271 23.612 18.271 22.8378C18.271 22.0636 18.901 21.4343 19.6752 21.4343ZM19.3084 24.9049V27.3507H20.0084V24.9084C21.0094 24.7474 21.7794 23.8843 21.7794 22.8378C21.7794 21.6779 20.8351 20.7343 19.6752 20.7343C18.5153 20.7343 17.571 21.6779 17.571 22.8378C17.571 23.8724 18.3228 24.7299 19.3084 24.9049ZM13 29.1098H26.3084V18.6H13V29.1098ZM15.8322 14.7388C15.8322 12.622 17.5542 10.9 19.6703 10.9C21.7871 10.9 23.5084 12.622 23.5084 14.7388V17.9H15.8322V14.7388ZM26.6584 17.9H24.2084V14.7388C24.2084 12.2356 22.1721 10.2 19.6703 10.2C17.1678 10.2 15.1322 12.2356 15.1322 14.7388V17.9H12.65C12.4561 17.9 12.3 18.0568 12.3 18.25V29.4598C12.3 29.653 12.4561 29.8098 12.65 29.8098H26.6584C26.8516 29.8098 27.0084 29.653 27.0084 29.4598V18.25C27.0084 18.0568 26.8516 17.9 26.6584 17.9Z" fill="white"/>
    <path d="M34 6.00002H6V34H34V6.00002ZM35.2727 35.2728H4.72727V4.72729H35.2727V35.2728Z" fill="white"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const awsSubnetIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAwsSubnetIcon,
);
